export default __webpack_public_path__ + "7b835e2a871202c8522c2aa0717a6a69.webp";